var modules_c05201b4 = {"storeButton":"_1grg1so","bgDark":"_1l442t0"};
import "../../../assets/x0GcvSZh.css";

export { modules_c05201b4 as default };
//# sourceMappingURL=Store.module.less.js.map
